import * as React from 'react';

import logo from '../../../../../brand-logo.png';

import {Table} from 'reactstrap';

class RecapReportHeader extends React.Component {
    public props: any;

    public state = {
        recap: this.props.recap
    };

    constructor(props: any) {
        super(props);

        this.engineers = this.engineers.bind(this);
    }

    public componentWillReceiveProps(nextProps: any) {
        this.setState({
            recap: nextProps.recap
        });
    }

    public engineers() {
        let engineerList: string = "";
        if (this.state.recap && this.state.recap.header.engineers[0]) {
            this.state.recap.header.engineers.map((engineer: any, index: number) => {
                engineerList += (engineer.firstName + ' ' + engineer.lastName + ', ');
            });
        }
        return engineerList.slice(0, -2);
    }

    public render() {
        return(
            <div className="RecapReportHeader">
                <Table>
                    <tbody>
                        <tr>
                            <td style={{'textAlign': 'center'}}>
                                <h5>Drilling</h5>
                            </td>
                            <td className="label">Operator</td>
                            <td colSpan={3}>{this.state.recap && this.state.recap.header.operator.operatorName}</td>
                            <td className="label">Contractor</td>
                            <td colSpan={3}>{this.state.recap && this.state.recap.header.contractor.contractorName}</td>
                        </tr>
                        <tr>
                            <td style={{'textAlign': 'center'}}>
                                <h5>Mud Recap</h5>
                            </td>
                            <td className="label">Well Name</td>
                            <td colSpan={3}>{this.state.recap && this.state.recap.header.wellName}</td>
                            <td className="label">Rig Number</td>
                            <td colSpan={3}>{this.state.recap && this.state.recap.header.rigNumber}</td>
                        </tr>
                        <tr>
                            <td rowSpan={5}>
                                <img src={logo}/>
                            </td>
                            <td className="label">Latitude</td>
                            <td>{this.state.recap && this.state.recap.header.shlgpsLatitude}</td>
                            <td className="label">Longitude</td>
                            <td>{this.state.recap && this.state.recap.header.shlgpsLongitude}</td>
                            <td className="label">Spud Date</td>
                            <td>{this.state.recap && this.state.recap.header.spudDate}</td>
                            <td className="label">Days</td>
                            <td>???</td>
                        </tr>
                        <tr>
                            <td className="label">API Number</td>
                            <td colSpan={3}>{this.state.recap && this.state.recap.header.apiNumber}</td>
                            <td className="label">Finish Date</td>
                            <td colSpan={3}>{this.state.recap && this.state.recap.header.finishDate}</td>
                        </tr>
                        <tr>
                            <td className="label">Legal</td>
                            <td colSpan={3}>{this.state.recap && this.state.recap.header.spudDate}</td>
                            <td className="label">Depth (MD)</td>
                            <td>
                                {this.state.recap &&
                                 this.state.recap.intervals[0] &&
                                 this.state.recap.intervals[this.state.recap.intervals.length - 1].wellTests[0] &&
                                 this.state.recap.intervals[this.state.recap.intervals.length - 1].wellTests[0].depthMD
                                }
                            </td>
                            <td className="label">Depth (TVD)</td>
                            <td>
                                {this.state.recap &&
                                 this.state.recap.intervals[0] &&
                                 this.state.recap.intervals[this.state.recap.intervals.length - 1].wellTests[0] &&
                                 this.state.recap.intervals[this.state.recap.intervals.length - 1].wellTests[0].depthTVD
                                }
                            </td>
                        </tr>
                        <tr>
                            <td className="label">County</td>
                            <td colSpan={3}>{this.state.recap && this.state.recap.header.countyParish}</td>
                            <td className="label">Engineer(s)</td>
                            <td colSpan={3}>{this.engineers()}</td>
                        </tr>
                        <tr>
                            <td className="label">State</td>
                            <td colSpan={8}>{this.state.recap && this.state.recap.header.state}</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default RecapReportHeader;



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/RecapReport/RecapReportHeader/RecapReportHeader.tsx